import React from "react";

import { TextField } from "../../../../components";

const Input = React.memo(
  ({ state, field, editState, dispatch, multiline = false }) => {
    const handleFieldChange = (value, name, key) => {
      dispatch({ type: "UPDATE_FIELD", payload: { value, name, key } });
    };

    return (
      <TextField
        multiline={multiline}
        size="small"
        name={field.field_name}
        label={field.field_label}
        value={state?.[field.field_name]?.value}
        placeholder={"Enter " + field.field_label}
        inputProps={{
          onChange: (e) =>
            handleFieldChange(e.target.value, field.field_name, "value"),
        }}
        disabled={!editState}
      />
    );
  }
);
export default Input;
